import { withSvgIcon } from './withSvgIcon';

export const ArrowLeftBig = withSvgIcon(
  <path
    d="M11 19L4 12M4 12L11 5M4 12L19 12"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
